import React, { useState, useEffect, useRef } from "react";
import "./Terminal.css";

const Terminal = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [passwordInput, setPasswordInput] = useState("");
  const [incorrectPassword, setIncorrectPassword] = useState(false);
  const correctPassword = process.env.REACT_APP_CORRECT_PASSWORD;


  //password sound effects
  const audioWrong = new Audio("/sounds/wrPsswrd.wav");
  const audioCorrect = new Audio("/sounds/crPsswrd.wav");
  //initial password checking function
  const handlePasswordSubmit = (e) => {
    e.preventDefault();
    if (passwordInput === correctPassword) {
      setIsAuthenticated(true);
      setIncorrectPassword(false);
      if (audioCorrect) {
        audioCorrect.play().catch((err) => console.log("Audio error:", err));
      }
    } else {
      setIncorrectPassword(true);
      setPasswordInput("");
      if (audioWrong) {
        audioWrong.play().catch((err) => console.log("Audio error:", err));
      }
    }
  };
  //password component
  return (
    <div className="terminal-container">
      {!isAuthenticated ? (
        <div className="password-screen">
          <h2>Turn the sound on to enjoy whle competing</h2>
          <h2>Enter Password to Access the Terminal</h2>
          <form onSubmit={handlePasswordSubmit}>
            <input
              type="password"
              value={passwordInput}
              autoFocus
              onChange={(e) => setPasswordInput(e.target.value)}
              placeholder="Enter password..."
              className="password-input"
            />
            <button type="submit" className="submit-btn">
              Unlock
            </button>
          </form>
          {incorrectPassword && (
            <p className="error-msg">Incorrect Password! Try again.</p>
          )}
        </div>
      ) : (
        <TerminalContent />
      )}
    </div>
  );
};

const TerminalContent = () => {
const encryptionKey = process.env.REACT_APP_ENCRYPTION_KEY;
  const [socket, setSocket] = useState(null);
  //initial msg
  const [logs, setLogs] = useState([
    `
▗▄▄▄▗▖  ▗▖▗▄▄▖▗▄▖ ▗▄▄▗▖  ▗▗▄▄▄▗▄▄▄▗▄▖     ▗▄▄▄▗▖  ▗▗▖  ▗▗▄▄▄▖▗▄▄▗▄▄▄▗▄▄▄▖▗▄▄▖▗▄▗▄▄▄▗▄▄▄▖▗▄▖▗▖  ▗▖
  █ ▐▛▚▖▐▐▌  ▐▌ ▐▐▌  ▐▛▚▖▐▌ █   █▐▌ ▐▌      █ ▐▛▚▖▐▐▌  ▐▐▌  ▐▌    █   █ ▐▌  ▐▌ ▐▌█   █ ▐▌ ▐▐▛▚▖▐▌
  █ ▐▌ ▝▜▐▌  ▐▌ ▐▐▌▝▜▐▌ ▝▜▌ █   █▐▌ ▐▌      █ ▐▌ ▝▜▐▌  ▐▐▛▀▀▘▝▀▚▖ █   █ ▐▌▝▜▐▛▀▜▌█   █ ▐▌ ▐▐▌ ▝▜▌    
▗▄█▄▐▌  ▐▝▚▄▄▝▚▄▞▝▚▄▞▐▌  ▐▗▄█▄▖ █▝▚▄▞▘    ▗▄█▄▐▌  ▐▌▝▚▞▘▐▙▄▄▗▄▄▞▘ █ ▗▄█▄▝▚▄▞▐▌ ▐▌█ ▗▄█▄▝▚▄▞▐▌  ▐▌

        
      Congratulations on qualifying for the second round! 

-Commands Guide:
   ls                 - List files and directories in the current path.
   pwd                - Show the present working directory.
   cd <foldername>    - Change directory.
   cd ..              - Go back to the previous directory.
   clear              - Clear the terminal screen.
   help               - Display this user guide again.
   cat <filename> <password> - View file contents (some files require a password).


For further assistance, please contact the system administrator.
                                                                                         
        `,
  ]);
  const [input, setInput] = useState("");
  const inputRef = useRef(null);
  const [showCursor, setShowCursor] = useState(true);
  const terminalContentRef = useRef(null);
  //type and submit audios
  const audioType = new Audio("/sounds/type.mp3");
  const audioSubmit = new Audio("/sounds/submit.wav");

  //filename encrypting function
  function encrypt(text, key) {
    let encryptedText = "";
    for (let i = 0; i < text.length; i++) {
        let charCode = text.charCodeAt(i); // Get ASCII value
        let keyCode = key.charCodeAt(i % key.length); // Get ASCII from key (looping)
        let encryptedChar = (charCode ^ keyCode).toString(16).padStart(4, "0"); // XOR, Convert to Hex, Pad to 4 chars
        encryptedText += encryptedChar;
    }
    return encryptedText;
}

  useEffect(() => {
    // WebSocket setup
    const ws = new WebSocket("ws://localhost:8080");

    ws.onmessage = (event) => {
      const response = event.data;
      if (response === "CLEAR_TERMINAL") {
        setLogs([]);
      } else if (response.startsWith("OPEN_FILE")) {
        let filename = response.split(" ")[1];
        const ext = filename.split(".")[1];
        filename = filename.split(".")[0];
        const updatedName = encrypt(filename, encryptionKey);
        if (ext === "exe") {
          // Force download for .exe files
          const a = document.createElement("a");
          a.href = `/GDVAQZ/${updatedName}.${ext}`;
          a.download = `${updatedName}.${ext}`; // Suggested filename
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
      }
      else{
        window.open(`/GDVAQZ/${updatedName}.${ext}`, "_blank");
      }
        setLogs((prev) => [...prev, response]);
      } else {
        setLogs((prev) => [...prev, response]);
      }
    };

    setSocket(ws);

    return () => {
      ws.close();
    };
  }, []);


  useEffect(() => {
    // Cursor blinking
    const cursorInterval = setInterval(() => {
      setShowCursor((prev) => !prev);
    }, 500);

    // Keep input focused
    const keepFocus = () => inputRef.current?.focus();
    ["click", "keydown", "mousemove", "touchstart"].forEach((event) =>
      document.addEventListener(event, keepFocus)
    );

    // Auto-scroll terminal
    if (terminalContentRef.current) {
      terminalContentRef.current.scrollTop =
        terminalContentRef.current.scrollHeight;
    }

    // Cleanup function
    return () => {
      clearInterval(cursorInterval);
      ["click", "keydown", "mousemove", "touchstart"].forEach((event) =>
        document.removeEventListener(event, keepFocus)
      );
    };
  }, [logs]);

  // command input check function
  const handleSubmit = (e) => {
    e.preventDefault();
    if (socket && input.trim()) {
      socket.send(input);
      setLogs((prev) => [...prev, `$ ${input}`]);
      setInput("");

      if (audioSubmit) {
        audioSubmit.play().catch((err) => console.log("Audio error:", err));
      }
    }
  };
  //input change function
  const handleInputChange = (e) => {
    setInput(e.target.value);

    if (audioType) {
      audioType.play().catch((err) => console.log("Audio error:", err));
    }
  };
  //Terminal component
  return (
    <div className="terminal-content" ref={terminalContentRef}>
      {logs.map((log, index) => (
        <div key={index} className="terminal-log">
          {log}
        </div>
      ))}
      <form onSubmit={handleSubmit} className="terminal-input">
        <span className="prompt">$ </span>
        <span className="input-text">{input}</span>
        <span className={`cursor ${showCursor ? "blink" : ""}`}>█</span>
        <input
          ref={inputRef}
          type="text"
          value={input}
          onChange={handleInputChange}
          autoFocus
          className="terminal-input-field"
        />
      </form>
    </div>
  );
};

export default Terminal;
